export const LinkIcon = ({
  className = 'text-action-primary h-3 w-6',
}: {
  className?: string;
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 0H14.4C13.74 0 13.2 0.54 13.2 1.2C13.2 1.86 13.74 2.4 14.4 2.4H18C19.98 2.4 21.6 4.02 21.6 6C21.6 7.98 19.98 9.6 18 9.6H14.4C13.74 9.6 13.2 10.14 13.2 10.8C13.2 11.46 13.74 12 14.4 12H18C21.312 12 24 9.312 24 6C24 2.688 21.312 0 18 0ZM7.2 6C7.2 6.66 7.74 7.2 8.4 7.2H15.6C16.26 7.2 16.8 6.66 16.8 6C16.8 5.34 16.26 4.8 15.6 4.8H8.4C7.74 4.8 7.2 5.34 7.2 6ZM9.6 9.6H6C4.02 9.6 2.4 7.98 2.4 6C2.4 4.02 4.02 2.4 6 2.4H9.6C10.26 2.4 10.8 1.86 10.8 1.2C10.8 0.54 10.26 0 9.6 0H6C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12H9.6C10.26 12 10.8 11.46 10.8 10.8C10.8 10.14 10.26 9.6 9.6 9.6Z"
        fill="currentColor"
      />
    </svg>
  );
};
